import React from "react";
import {useSelector} from "react-redux";
import MobileActiveRoomTabItem from "./MobileActiveRoomTabItem";

function MobileActiveRoomTabs() {
    const enteredRooms = useSelector(store => store.rooms);
    return <ul className="mobile-header-active-games">
        {
            Object.keys(enteredRooms)?.map((roomId, index) => {
                const room = enteredRooms?.[roomId]
                if (!room?.isVisibleRoom && !room?.historyRoomPlayer) return;
                return (
                <MobileActiveRoomTabItem
                    key={index}
                    id={roomId}
                    isViewRoom={room?.isViewRoom}
                    isHistoryRoom={room?.historyRoomPlayer}
                    isTournamentRoom={room?.tournamentId}
                    notifier={room?.notifier}
                />
            )
            })
        }
    </ul>
}

export default MobileActiveRoomTabs;
